import { render, staticRenderFns } from "./Habits.vue?vue&type=template&id=97213a36&scoped=true&"
import script from "./Habits.vue?vue&type=script&lang=js&"
export * from "./Habits.vue?vue&type=script&lang=js&"
import style0 from "./Habits.vue?vue&type=style&index=0&id=97213a36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97213a36",
  null
  
)

export default component.exports